import { ElasticUserActionQuery } from '@mark43/cad-api';
import { last36HoursTimeRangeOption } from './constants';
import { UnitHistoryForm } from './types';
import { timeRangeValueToDateRange } from './utils';

export function unitHistoryFormToElasticUserActionQuery(
    unitHistoryForm: UnitHistoryForm
): ElasticUserActionQuery {
    const { unitOption, userOption, dateRange } = unitHistoryForm;
    const defaultDateRange = timeRangeValueToDateRange(last36HoursTimeRangeOption.value);
    return {
        unitIds: unitOption?.value ? [unitOption.value] : [],
        userIds: userOption?.value ? [userOption.value] : [],
        createdDateRangeQuery: {
            startDateUtc: (dateRange ?? defaultDateRange).start,
            endDateUtc: (dateRange ?? defaultDateRange).end,
        },
        ...boilerplateProperties,
    };
}

const boilerplateProperties = {
    actionTypesToExclude: [],
    actionTypesToInclude: [],
    agencyEventIds: [],
    boloIds: [],
    departmentIds: [],
    fuzzyMatchingEnabled: false,
    ids: [],
};
